import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['Martín R.', 'Juan C.', 'Lucas G.', 'Nicolás R.', 'Carlos S.', 'Diego F.', 'Emiliano M.', 'Sebastián P.', 'Franco T.', 'Nahuel B.', 'Andrés V.', 'Pablo H.', 'Ramiro D.', 'Facundo A.', 'Gonzalo N.', 'Alejandro K.', 'Damián O.', 'Fernando E.', 'Santiago I.', 'Gustavo W.', 'Leandro Z.', 'Hernán J.', 'Matías Q.', 'Rodrigo U.', 'César X.'];
const cities = ['Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Buenos Aires', 'Guadalajara', 'Medellín', 'Monterrey', 'Quito', 'Guayaquil', 'Montevideo', 'Asunción', 'San José', 'Ciudad de Panamá', 'Santo Domingo', 'Córdoba', 'Rosario', 'Cali', 'Arequipa', 'Puebla', 'Valparaíso', 'Barranquilla', 'La Paz'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-396" data-mp="1a1k40puk0mrt">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-6 left-4 z-[60] max-w-xs" data-id="element-397" data-mp="1a2lhf0z1llcp">
          <div className="bg-bg-card rounded-[20px] shadow-2xl border border-line p-4 flex items-start gap-3" data-id="element-398" data-mp="1r1mzlxmk4db2">
            <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center shrink-0" data-id="element-399" data-mp="1vu6dywt2jcgx">
              <ShoppingBag size={20} className="text-success" data-id="element-400" data-mp="20ry87xh6raoa" />
            </div>
            <div data-id="element-401" data-mp="24srt0hzc09cy">
              <p className="text-sm font-bold text-txt-primary" data-id="element-402" data-mp="24s9nsvuoyksw">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-txt-body" data-id="element-403" data-mp="29rcwcq9vr95m">
                compró el{' '}
                <span className="font-bold text-brandGold" data-id="element-404" data-mp="2eq68ofdfku47">
                  Megapack Colorimetría Lista
                </span>
              </p>
              <p className="text-xs text-txt-muted mt-1" data-id="element-405" data-mp="kdpwyz1v8nry">
                hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-txt-muted hover:text-txt-primary text-xs ml-auto shrink-0 mt-0.5" aria-label="Cerrar notificación" data-id="element-406" data-mp="cw9rwegi2x7q">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}